import { CardActions, Typography, Stack, Chip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';

export const TitlePage = ({ title, subtitle, buttonTitle }) => {

    const navigate = useNavigate();

    const handleClick = () => {
        if (title === 'Clientes') {
            navigate('/addClient');
        } else if (title === 'Presupuestos' || title === 'Presupuestos provisionales' || title === 'Presupuestos aceptados' || title === 'Obras') {
            navigate('/addEstimate');
        } else if (title === 'Certificaciones') {
            navigate('/addCertification');
        } else if (title === 'Productos') {
            navigate('/addProducts')
        } else if (title === 'Usuarios') {
            navigate('/addUser')
        }

    }

    return (
        <Stack flexDirection='row' justifyContent='space-between' sx={{ minWidth: 500, width: '100%', marginBottom: '2rem' }} >
            <Stack>
                <Typography variant="h3" component="h1">
                    {title}
                </Typography>
                <Typography sx={{ mb: 1.5 }} variant='caption' color="text.secondary">
                    {subtitle}
                </Typography>
            </Stack>
            {(title !== 'Obras' && title !== 'Próximas llamadas') &&
                <CardActions >
                    <Chip color='primary' icon={<AddIcon sx={{ mr: 1 }} />} label={buttonTitle} onClick={handleClick} />
                </CardActions>
            }
        </Stack>
    )
}